import React from "react";
import { checkTranslation, getObject, paramsToValue, translate } from "../../utils/useful";

let moment = require('jalali-moment');
class Month extends React.Component {
    state = {
        // isOpen: false,
        // startOfMonth: '',
        // endOfMonth: '',
        // week: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        days: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,],
        month: { startDay: 0, daysCount: 30 },
        monthFromNow: 0,
        today: '',
        // months: [
        //     { title: 'January' },
        //     { title: 'February' },
        //     { title: 'March' },
        //     { title: 'April' },
        //     { title: 'May' },
        //     { title: 'June' },
        //     { title: 'July' },
        //     { title: 'August' },
        //     { title: 'September' },
        //     { title: 'October' },
        //     { title: 'November' },
        //     { title: 'December' },
        // ],
        taskDays: [],
        years: [],
        key: 'TEpyxZL1neC2JBZViuDaJ'

    }




    componentDidMount() {
        // this.setState({ data: this.props.data })

        // this.getTaskDuration()
        // this.setState({ title: this.props.title, today: new Date().getTime() })
        // window.addEventListener('resize', this.changeWidth);
        // setTimeout(() => {
        //     this.changeWidth()
        // }, 100);

        // if (this.props.title) {
        //     this.setMonth(0, this.props.title)

        // } else {
        //     this.setMonth(0)
        // }
    }

    changeMonth(number) {
        this.setMonth(this.state.monthFromNow + number)
        this.setState({ monthFromNow: this.state.monthFromNow + number })
    }

    setMonth(fromNow, startDate) {
        let now = new Date();
        let days = []

        let start = moment(now).startOf('month').add(fromNow, 'month').startOf('month')

        if (startDate) {
            start = moment(startDate).add(fromNow, 'month').startOf('month')
        }
        // console.log(moment(now).add(fromNow, 'month').daysInMonth())
        for (let i = 0; i < moment(now).add(fromNow, 'month').daysInMonth(); i++) {
            days.push({ start: moment(start).add(i, 'day').startOf('day').valueOf(), end: moment(start).add(i, 'day').endOf('day').valueOf() })
        }
        let newDate = [Number(moment(start).format('YYYY')), moment(start).format('M') - 1, 1]
        this.setState({ month: { title: moment(start).format('YYYY-MMMM'), month: moment(start).format('MMMM'), monthNumber: moment(start).format('M') - 1, year: Number(moment(start).format('YYYY')), startDay: start.day(), days: days } }, () => {
        })

    }

    setDay(day, dayNumber) {

        this.setState({ title: day.start })
        if (this.props.onChange) {
            this.props.onChange(this.props.headerkey, { type: 'changeDay', newDay: day.start, dayNumber })
        }

    }
    changeData = (day) => {
        let showData = this.state.data
        let key = this.state.key
        if (showData) {
            showData = showData.filter(cdata => moment(cdata?.values[key]).format('YYYY MM DD') === moment(day).format('YYYY MM DD'))
        }
        // this.setState({ showData, })
        return showData
    }
    // getTaskDuration = () => {
    //     let startTime, endTime, dueTime
    //     let taskDays = []
    //     let promises = []
    //     for (let i = 0; i < this.props.tasks?.length; i++) {
    //         promises.push(new Promise((resolve) => {

    //             if (this.props.tasks[i].timeline) {
    //                 startTime = moment(new Date(this.props.tasks[i].timeline.startTime)).format('YYYY-MM-DD')
    //                 // console.log('year', startTime);
    //                 taskDays.push(startTime)
    //                 // console.log('taskdays', taskDays);
    //                 endTime = moment(new Date(this.props.tasks[i].timeline.endTime)).format('YYYY-MM-DD')
    //                 dueTime = moment(new Date(this.props.tasks[i].timeline.dueTime)).format('YYYY-MM-DD')
    //                 resolve()
    //             }
    //             else {
    //                 resolve()
    //             }

    //         }))
    //     }
    //     Promise.all(promises).then(() => {

    //         this.setState({ taskDays })
    //     })

    // }


    actionClicked = (prop, data, index) => {
        if (this.props.functionsHandler) {
            this.props.functionsHandler('collection', prop, data, index)
        }
    }





    showDays() {

        let calender = this.props.currentCalendar
        let month = calender.getMonth()
        // console.log(month)


        // let week = []
        // let weeks = []
        // let days = []
        // let startDay = this.state.month.startDay
        let count = 0

        // for (let i = 0; i < startDay - 1; i++) {
        //     days.push(null)
        // }
        // if (!this.state.month.days) {
        //     return
        // }

        // days = [...days, ...this.state.month.days]
        // // console.log(this.state.month.days);

        // for (let i = 0; i < days.length; i++) {

        //     count++
        //     week.push(days[i])
        //     if (count == 7 || i == days.length - 1) {
        //         weeks.push(week)
        //         count = 0
        //         week = []
        //     }
        // }

        // // console.log(weeks)

        // let lastWeekLenght = weeks[weeks.length - 1].length
        // if (lastWeekLenght < 7) {
        //     for (let i = 0; i < 7 - lastWeekLenght; i++) {

        //         weeks[weeks.length - 1].push(null)
        //     }
        // }

        // count = 0


        return month.map((week, index) => {

            return (
                <div key={index} className="d-flex text-center w-100 " style={{ justifyContent: 'space-between' }}>
                    {week.map((day, index1) => {

                        if (day == null) {
                            return (
                                <div key={index1} style={{ textTransform: 'uppercase', width: '100%', margin: -1, borderRight: '1px solid #e6e6e6', borderBottom: '1px solid #e6e6e6', background: '' }}>
                                </div>
                            )
                        } else {
                            // console.log('test2345', this.changeData(day.start))
                            count++
                            let dayNumber = count

                            const isToday = calender.todayKey == day.key
                            const isSelected = false//calender.activeDay?.key == day.key
                            let data = []
                            if (this.props.daysData && this.props.daysData[day?.key]) {
                                data = this.props.daysData[day.key]
                            }

                            // console.log(day?.key)
                            // console.log(this.props.daysData)
                            // console.log(data)


                            // let isSelected = (this.state.title >= day.start && this.state.title <= day.end) ? true : false
                            // console.log(isSelected, "isSelected")
                            return (
                                <div onClick={() => this.setDay(day, dayNumber)} key={index1} style={{ overflow: 'hidden', cursor: 'pointer', width: '100%', backgroundColor: '#fff', zIndex: isSelected ? '10' : '0', minHeight: this.props.width ? (this.props.width / 7) : 80, justifyContent: 'center', alignItems: 'center', display: 'flex', border: isSelected ? '1px solid black' : '1px solid #e6e6e6', margin: -1 }}>
                                    <div onDragOver={this.handleDragOver} onDrop={(event) => this.handleDrop(event, day)} style={{ backgroundColor: this.state.taskDays.includes(this.state.month.year + '-' + (this.state.month.monthNumber + 1) + '-' + (count < 10 ? '0' + count : count)) && 'red', padding: "4px 4px 3px 4px", width: "100%", height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'center', paddingTop: "5x" }}>
                                        {data && data.length > 0 && (
                                            <div className="flex-1 w-100">
                                                {data?.map((prop, index) => {
                                                    let keyText = this.props.view?.settings?.stacked?.viewKey
                                                    // let value = getObject(prop, keyText)

                                                    let value = paramsToValue(prop, keyText, this.props.headers, 'View Record', true)


                                                    return (
                                                        <div key={prop._id} onClick={() => this.actionClicked('openEditModal', prop, index)} className="w-100 p-1 text-start mb-1 text-semibold" style={{ borderRadius: 3, background: 'rgba(86, 84, 214,0.08)', color: 'rgba(86, 84, 214,1)', border: '0px solid #ddd' }} draggable id={prop._id} onDragStart={(event) => this.handleDragStart(event, prop)}>
                                                            <p style={{ fontSize: 12 }}> {value}</p>
                                                            {/* <p style={{ fontSize: 8 }}> {moment(prop?.values[this.state.key]).format('YYYY MM DD')}</p> */}
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        )}
                                        <div className="flexc justify-content-end w-100 mt-1" >
                                            <p className="text-semibold px-1" style={{ color: isSelected ? '#007aff' : '#999', fontSize: 11, }}>{count}</p>
                                        </div>
                                        {/* <div className="flexcc w-100 flex-column">
                                            {data && Array.isArray(data[count]) && (
                                                <>
                                                    <div className="w-100 text-center" style={{ overflow: 'hidden', backgroundColor: '#42BECA', padding: '5px 5px', borderRadius: 4, marginTop: 3 }}>
                                                        <p style={{ fontSize: 10, color: '#757575', }}> {this.props.data[count].length}{this.state.width > 550 ? translate(" EVENTS") : ''}</p>
                                                    </div>
                                                </>
                                            )}

                                            {null}
                                        </div> */}
                                    </div>
                                </div>
                            )
                        }
                    })
                    }

                </div>
            )
        })




    }

    handleDragStart = (event, prop) => {
        this.setState({ draggedItem: prop })
        let i = document.getElementById(prop._id)
        event.dataTransfer.setDragImage(i, 0, 0);
    };
    handleDragOver = (event) => {
        event.preventDefault();
    };

    handleDrop = (event, day) => {

        let data = this.state.data
        let key = this.state.key
        data.forEach((item) => {
            if (item._id == this.state.draggedItem._id) {
                item.values[key] = day.start
            }
        })
        let item = this.state.draggedItem
        item.values[key] = day.start
        this.setState({ data }, () => {
            this.changeData()
        })
        this.props.submitForm(item, true)

        this.setState({
            draggedItem: null,
        })

    };


    componentWillUnmount() {
        document.removeEventListener('mousedown', this.closeBox);
        window.removeEventListener('resize', this.changeWidth);

    }

    // openBox() {
    //     document.addEventListener('mousedown', this.closeBox);
    //     this.setState({ isOpen: true })
    // }


    changeWidth = () => {
        if (this.calender) {
            let width = this.calender.getBoundingClientRect().width
            this.setState({ width })
        }
    }

    closeBox = (event) => {
        // if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.isOpen) {
        setTimeout(() => {
            this.setState({ showMonths: false, showYears: false })
        }, 300);
        document.removeEventListener('mousedown', this.closeBox);
        //     if (this.refs.icon)
        //         this.refs.icon.classList.toggle("rotate-180")

        // }
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    // conditionalSettings(param, condition) {
    //     if (this.props.settings) {
    //         if (this.props.settings[param] == condition) {
    //             return true
    //         }
    //     }
    //     return false
    // }

    showMonths = () => {
        this.setState({ showMonths: true, showYears: false })
        document.removeEventListener('mousedown', this.closeBox);
        setTimeout(() => {
            document.addEventListener('mousedown', this.closeBox);
        }, 500);

    }

    showYears = () => {
        let startYear = 2019
        let endYear = Number(moment().year())
        let years = []

        for (var i = startYear; i <= endYear; i++) {
            years.push(i);
        }

        this.setState({ showMonths: false, showYears: true, years })
        document.removeEventListener('mousedown', this.closeBox);
        setTimeout(() => {
            document.addEventListener('mousedown', this.closeBox);
        }, 500);

    }


    setNewDate = (type, prop, index) => {
        let oldDate = [this.state.month.year, this.state.month.monthNumber, 1]
        let newDate = [this.state.month.year, this.state.month.monthNumber, 1]

        if (type == 'month') {
            newDate[1] = index
        }
        if (type == 'year') {
            newDate[0] = prop
        }

        // console.log(newDate)

        // let oldDate = []//this.state.month.title.split('-')
        // oldDate.push(1)

        // oldDate[1] = moment().month(oldDate[1]).format("M");
        // console.log(oldDate)
        // 
        // console.log(moment(newDate).valueOf())


        let monthsDiff = moment(newDate).startOf('month').diff(moment(new Date()).startOf('month'), 'months', true)

        // console.log(monthsDiff)
        if (this.props.title) {
            this.setMonth(monthsDiff, this.props.title)

        } else {
            this.setMonth(monthsDiff)
        }
        // console.log(monthsDiff)
    }


    render() {

        let info = this.props.info
        let calender = this.props.currentCalendar

        return (
            <div ref={el => this.calender = el} className='w-100 h-100' style={{ paddingBottom: 70, backgroundColor: '#fff', direction: 'ltr' }}>
                <div className='' ref={ref => this.setWrapperRef(ref)}>
                    <div className="br-20 h-100" >
                        <div className="d-flex " style={{}}>
                            {/* <div className="flexc w-100 mt-2 mld-4">
                                <div className="d-flex">
                                    <div className="flexc">
                                        <p className="mld-3 font-size-15" style={{ cursor: 'pointer', textTransform: 'capitalize', minWidth: 85 }} onClick={() => this.showMonths()}>{checkTranslation(this.state.month.month)}</p>
                                        <p className="mrd-3 mld-3 font-size-15" style={{ cursor: 'pointer' }} onClick={() => this.showYears()}>{checkTranslation(this.state.month.year)}</p>
                                    </div>
                                </div>
                                <div className="flexcc">
                                    <img style={{ cursor: "pointer" }} onClick={() => this.changeMonth(+1)} width={17} className=" btn-hover1" src="/assets/icons/chevron.backward-gray.svg" />
                                    <img style={{ cursor: "pointer" }} width={18} className="" src="/assets/icons/dot.png" />
                                    <img style={{ cursor: "pointer" }} onClick={() => this.changeMonth(-1)} width={17} className=" btn-hover1" src="/assets/icons/chevron.forward-gray.svg" />
                                </div>
                            </div> */}


                            {/* {this.state.showMonths && (
                                    <div style={{ position: 'absolute', top: 24, backgroundColor: '#fff', borderRadius: 4, boxShadow: '0px 0px 100px #00000020', padding: '0px 0px', textAlign: 'center' }}>
                                        {this.state.months.map((prop, index) => {
                                            return (
                                                <div onClick={() => this.setNewDate('month', prop, index)} key={index} className="" style={{ cursor: 'pointer', borderBottom: '1px solid #eee', padding: '5px 35px' }}>
                                                    <p>{prop.title}</p>
                                                </div>
                                            )
                                        })}
                                    </div>
                                )}


                                {this.state.showYears && (
                                    <div style={{ position: 'absolute', top: 24, backgroundColor: '#fff', borderRadius: 4, boxShadow: '0px 0px 100px #00000020', padding: '0px 0px', textAlign: 'center' }}>
                                        {this.state.years.map((prop, index) => {
                                            return (
                                                <div onClick={() => this.setNewDate('year', prop, index)} key={index} className="" style={{ cursor: 'pointer', borderBottom: '1px solid #eee', padding: '5px 35px' }}>
                                                    <p>{prop}</p>
                                                </div>
                                            )
                                        })}
                                    </div>
                                )} */}

                            {/* <i onClick={() => this.changeMonth(1)} className="fa fa-arrow-right"></i> */}

                        </div>

                        <div className="d-flex    text-center w-100" style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff', borderBottom: '1px solid #eee' }}>
                            {calender?.weekDayNames?.map((prop, index) => {
                                return (
                                    <div className={'w-100 py-2'} style={{ borderRight: '1px solid #f0f0f0' }}>
                                        <p className="text-smaller text-semibold text-uppercase">{checkTranslation(prop)}</p>
                                    </div>
                                )
                            })}
                        </div>
                        {this.showDays()}
                    </div>
                </div>

                {this.props.isLoading && (
                    <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', backgroundColor: '#00000020', position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>

                    </div>
                )}

            </div>
        );
    }
}

export default Month;
